"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1367],{

/***/ 33445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; },
/* harmony export */   "l": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.l; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62073);


/***/ }),

/***/ 94441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Io": function() { return /* binding */ ModalHead; },
/* harmony export */   "fe": function() { return /* binding */ ModalBody; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "mz": function() { return /* binding */ ModalFooter; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_components_Elevation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33606);


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var ModalHead = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "elwqdxd3"
} : 0)( true ? {
  name: "1n7keil",
  styles: "display:flex;align-items:center;justify-content:space-between;gap:16px;flex:0 1 auto;padding:16px"
} : 0);
var ModalBody = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "elwqdxd2"
} : 0)( true ? {
  name: "1nhqexb",
  styles: "padding:24px;flex:1;overflow-y:auto"
} : 0);
var ModalFooter = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "elwqdxd1"
} : 0)( true ? {
  name: "ewsg4e",
  styles: "display:flex;justify-content:flex-end;flex:0 1 auto;padding:16px"
} : 0);
var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_components_Elevation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,  true ? {
  target: "elwqdxd0"
} : 0)("display:flex;flex-direction:column;width:100%;max-height:100%;border-radius:10px;overflow:hidden;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";max-width:", function (_ref2) {
  var maxWidth = _ref2.maxWidth,
      fullScreen = _ref2.fullScreen;
  return fullScreen ? "100%" : "".concat(maxWidth, "px");
}, ";height:", function (_ref3) {
  var fullScreen = _ref3.fullScreen;
  return fullScreen ? "100%" : "auto";
}, ";", ModalHead, "{border-bottom:1px solid ", function (_ref4) {
  var sectionSeparatorColor = _ref4.sectionSeparatorColor;
  return sectionSeparatorColor;
}, ";}", ModalFooter, "{border-top:1px solid ", function (_ref5) {
  var sectionSeparatorColor = _ref5.sectionSeparatorColor;
  return sectionSeparatorColor;
}, ";}" + ( true ? "" : 0));

/***/ }),

/***/ 33400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Modal_views/* ModalBody */.fe; },
  "$_": function() { return /* reexport */ Modal_views/* ModalFooter */.mz; },
  "Fb": function() { return /* reexport */ Modal_views/* ModalHead */.Io; },
  "ZP": function() { return /* reexport */ ModalBase; }
});

// UNUSED EXPORTS: Overlay

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Modal/ModalOverlay.tsx



var _excluded = ["placement", "background", "fullScreen", "fullScreenBottomOffset", "children", "customZIndex"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var ModalOverlay = /*#__PURE__*/(0,react.forwardRef)(function (_ref2, ref) {
  var _ref2$placement = _ref2.placement,
      placement = _ref2$placement === void 0 ? "top" : _ref2$placement,
      _ref2$background = _ref2.background,
      background = _ref2$background === void 0 ? "rgba(0, 0, 0, 0.48)" : _ref2$background,
      fullScreen = _ref2.fullScreen,
      fullScreenBottomOffset = _ref2.fullScreenBottomOffset,
      children = _ref2.children,
      _ref2$customZIndex = _ref2.customZIndex,
      customZIndex = _ref2$customZIndex === void 0 ? 99 : _ref2$customZIndex,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overlay, _objectSpread(_objectSpread({
    id: "modal-overlay",
    placement: placement,
    background: background,
    fullScreen: fullScreen,
    fullScreenBottomOffset: fullScreenBottomOffset,
    ref: ref,
    customZIndex: customZIndex
  }, rest), {}, {
    children: children
  }));
});

var _ref =  true ? {
  name: "1h3rtzg",
  styles: "align-items:center"
} : 0;

var Overlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e5irn6v0"
} : 0)("position:fixed;top:0;left:0;bottom:0;right:0;z-index:", function (_ref3) {
  var customZIndex = _ref3.customZIndex;
  return customZIndex;
}, ";display:flex;justify-content:center;align-items:start;background-color:", function (_ref4) {
  var background = _ref4.background;
  return background;
}, ";padding:", function (_ref5) {
  var fullScreen = _ref5.fullScreen,
      _ref5$fullScreenBotto = _ref5.fullScreenBottomOffset,
      fullScreenBottomOffset = _ref5$fullScreenBotto === void 0 ? 0 : _ref5$fullScreenBotto;
  return fullScreen ? "20px 20px ".concat(20 + fullScreenBottomOffset, "px 20px") : "60px 16px";
}, ";overflow:auto;", function (_ref6) {
  var placement = _ref6.placement;
  return placement === "center" && _ref;
}, " ", function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.up("md");
}, "{padding:", function (_ref8) {
  var fullScreen = _ref8.fullScreen,
      _ref8$fullScreenBotto = _ref8.fullScreenBottomOffset,
      fullScreenBottomOffset = _ref8$fullScreenBotto === void 0 ? 0 : _ref8$fullScreenBotto;
  return fullScreen ? "25px 25px ".concat(25 + fullScreenBottomOffset, "px 25px") : "64px";
}, ";}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../libs/matcha/components/Modal/Modal.views.tsx
var Modal_views = __webpack_require__(94441);
;// CONCATENATED MODULE: ../../libs/matcha/components/Modal/Modal.tsx


var Modal_excluded = ["tokens", "fullScreen", "fullScreenBottomOffset", "placement", "children", "customZIndex"];

function Modal_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Modal_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Modal_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Modal_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var Modal = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      fullScreen = _ref.fullScreen,
      fullScreenBottomOffset = _ref.fullScreenBottomOffset,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "top" : _ref$placement,
      children = _ref.children,
      customZIndex = _ref.customZIndex,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Modal_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalOverlay, {
    fullScreen: fullScreen,
    fullScreenBottomOffset: fullScreenBottomOffset,
    placement: placement,
    customZIndex: customZIndex,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal_views/* Wrapper */.im, Modal_objectSpread(Modal_objectSpread(Modal_objectSpread({}, tokens), {}, {
      role: "dialog",
      elevation: 1,
      ref: ref,
      fullScreen: fullScreen
    }, rest), {}, {
      children: children
    }))
  });
});
var sizes = {
  small: 384,
  medium: 448,
  large: 512,
  xlarge: 576
};
var ModalBase = (0,useDesignTokens/* withDesignTokens */.Y)(Modal, function (_ref2) {
  var size = _ref2.size;
  return {
    maxWidth: sizes[size || "medium"]
  };
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      sectionSeparatorColor: theme.palette.brand.darkAcai[200]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[600],
      sectionSeparatorColor: theme.palette.brand.darkAcai[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      sectionSeparatorColor: theme.palette.twilio.gray[20]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100],
      sectionSeparatorColor: theme.palette.twilio.gray[20]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      backgroundColor: theme.palette.cdpWeek2023.gray[90],
      sectionSeparatorColor: theme.palette.cdpWeek2023.gray[80]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/components/Modal/index.ts


ModalBase.displayName = "ModalBase";
Modal_views/* ModalHead.displayName */.Io.displayName = "Modal.Head";
Modal_views/* ModalBody.displayName */.fe.displayName = "Modal.Body";
Modal_views/* ModalFooter.displayName */.mz.displayName = "Modal.Footer";



/***/ }),

/***/ 47694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _usePortal__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _usePortal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75290);


/***/ }),

/***/ 75290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

/**
 * Creates DOM element to be used as React root.
 */

function createRootElement(id) {
  var rootContainer = document.createElement("div");
  rootContainer.setAttribute("id", id);
  return rootContainer;
}
/**
 * Appends element as last child of body.
 */


function addRootElement(rootElem) {
  if (document.body.lastElementChild) {
    document.body.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling);
  }
}
/**
 * Hook to create a React Portal.
 * Automatically handles creating and tearing-down the root elements (no SRR
 * makes this trivial), so there is no need to ensure the parent target already
 * exists.
 * @param id - The id of the root element to create.
 * @returns The root element.
 */


function usePortal(id) {
  var rootElemRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Look for existing target dom element to append to
    var existingParent = document.querySelector("#".concat(id)); // Parent is either a new root or the existing dom element

    var parentElem = existingParent || createRootElement(id); // If there is no existing DOM element, add a new one.

    if (!existingParent) {
      addRootElement(parentElem);
    } // Add the detached element to the parent


    if (rootElemRef.current) {
      parentElem.appendChild(rootElemRef.current);
    }

    return function () {
      var _rootElemRef$current;

      (_rootElemRef$current = rootElemRef.current) === null || _rootElemRef$current === void 0 ? void 0 : _rootElemRef$current.remove();

      if (!parentElem.childElementCount) {
        parentElem.remove();
      }
    };
  }, [id]);
  /**
   * It's important we evaluate this lazily:
   * - We need first render to contain the DOM element, so it shouldn't happen
   *   in useEffect. We would normally put this in the constructor().
   * - We can't do 'const rootElemRef = useRef(document.createElement('div))',
   *   since this will run every single render (that's a lot).
   * - We want the ref to consistently point to the same DOM element and only
   *   ever run once.
   * @link https://reactjs.org/docs/hooks-faq.html#how-to-create-expensive-objects-lazily
   */

  function getRootElem() {
    if (!rootElemRef.current && true) {
      rootElemRef.current = document.createElement("div");
    }

    return rootElemRef.current;
  }

  return getRootElem();
}

/* harmony default export */ __webpack_exports__["Z"] = (usePortal);

/***/ })

}]);